export const TRACKING_PIXEL_TYPES = {
  GOOGLE_ANALYTICS: "GOOGLE_ANALYTICS",
  GOOGLE_TAG_MANAGER: "GOOGLE_TAG_MANAGER",
  FACEBOOK: "FACEBOOK",
  LINKEDIN: "LINKEDIN",
  MUNCHKIN: "MUNCHKIN",
  SIXSENSE: "SIXSENSE",
} as const;

export type TrackingPixelType = keyof typeof TRACKING_PIXEL_TYPES;

export interface TrackingPixel {
  uid: string;
  type: TrackingPixelType;
  value: string;
}
